let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("176N4")).then(() => parcelRequire('hKEgw'));